import { empresaDataInterface } from "../../pages/Empresa/empresa";

export const rootkeyData: empresaDataInterface = {
    "color": "rgba(184, 0, 230, 1)",
    "link": "/rootkey",
    "icon":"https://media.grupoinveste.pt/emp/rootkey/icon.png",
    "logo_white":"https://media.grupoinveste.pt/emp/rootkey/horizontal_white.png",
    "logo_vertical":"https://media.grupoinveste.pt/emp/rootkey/vertical_white.png",
    "header": {
        "website": "https://rootkey.ai",
        "banner": "https://media.notcybersec.com/website/Home/homeSection1.png",
        "tags": [
            "rootkey.tags.0", "rootkey.tags.1", "rootkey.tags.2",
        ],
        "name": "rootkey.name",
        "slogan": "rootkey.slogan"
    },
    "section1": {
        "img": "https://media.grupoinveste.pt/emp/rootkey/horizontal_black.png",
        "title_1": "rootkey.section1.title1",
        "text_1": "rootkey.section1.text1",
        "text_2": "rootkey.section1.text2",
        "title_2": "rootkey.section1.title2",
        "text_3": "rootkey.section1.text3",
        "text_4": "rootkey.section1.text4",
    },
    "section2": [
        {
            "title": "rootkey.section2.0.title",
            "text": [
                "rootkey.section2.0.text.0", "rootkey.section2.0.text.1", "rootkey.section2.0.text.2", "rootkey.section2.0.text.3"
            ]
        },
        {
            "title": "rootkey.section2.1.title",
            "text": [
                "rootkey.section2.1.text.0", "rootkey.section2.1.text.1", "rootkey.section2.1.text.2"
            ]
        },
        {
            "title": "rootkey.section2.2.title",
            "text": [
                "rootkey.section2.2.text.0", "rootkey.section2.2.text.1"
            ]
        },
        {
            "title": "rootkey.section2.3.title",
            "text": [
                "rootkey.section2.3.text.0", "rootkey.section2.3.text.1", "rootkey.section2.3.text.2"
            ]
        }
    ],
    "section3": {
        "title": "rootkey.section3.title",
        "text": "rootkey.section3.text",
        "link": "https://rootkey.ai/contact"
    }
}